
(function () {
  "use strict";
  const OFFERS = [
    {
      collection: "share-bag-range",
      triggerQty: 10,
      title: "Don't Forget Your FREE Share Box! 🎉",
      message: "You have added 10 Share Boxes to your cart, Add the 11th box for FREE",
    },
    {
      collection: "50p-range",
      triggerQty: 10,
      title: "Don't forget your FREE Outer! 🎉",
      message: "You have added 10 Outers to your cart, Add the 11th Outer for FREE.",
    },
  ];
  // --------------------------------------------------------------------

  const collectionCache = {};

  async function getCollectionProductIds(handle) {
    if (collectionCache[handle]) return collectionCache[handle];
    const ids = new Set();
    for (let page = 1; page <= 20; page++) {
      const res = await fetch(`/collections/${handle}/products.json?limit=250&page=${page}`);
      if (!res.ok) break;
      const data = await res.json();
      if (!data.products || data.products.length === 0) break;
      data.products.forEach((p) => ids.add(p.id));
      if (data.products.length < 250) break;
    }
    collectionCache[handle] = ids;
    return ids;
  }

  async function getCart() {
    const res = await fetch("/cart.js");
    return res.json();
  }

  async function evaluate() {
    const cart = await getCart();
    for (const offer of OFFERS) {
      const ids = await getCollectionProductIds(offer.collection);
      const items = cart.items.filter((i) => ids.has(i.product_id));
      const qty = items.reduce((n, i) => n + i.quantity, 0);
      if (qty === 0) continue;

      // Fire when the customer hits a full set of triggerQty (10, 20, 30, ...).
      if (qty >= offer.triggerQty && qty % offer.triggerQty === 0) {
        const key = `freeprompt-${offer.collection}-${qty}`;
        if (sessionStorage.getItem(key)) continue;
        showPopup(offer, key);
        return; // one popup at a time
      }
    }
  }

  function showPopup(offer, dismissKey) {
    if (document.getElementById("free-item-popup")) return;

    const wrap = document.createElement("div");
    wrap.id = "free-item-popup";
    wrap.innerHTML = `
      <div class="fip-backdrop"></div>
      <div class="fip-modal" role="dialog" aria-modal="true" aria-label="${offer.title}">
        <button class="fip-close" aria-label="Close">&times;</button>
        <h3>${offer.title}</h3>
        <p>${offer.message}</p>
        <button class="fip-ok">Got it</button>
      </div>`;
    document.body.appendChild(wrap);

    const close = () => {
    //  sessionStorage.setItem(dismissKey, "1");
      wrap.remove();
    };
    wrap.querySelector(".fip-close").onclick = close;
    wrap.querySelector(".fip-ok").onclick = close;
    wrap.querySelector(".fip-backdrop").onclick = close;
  }

  const css = document.createElement("style");
  css.textContent = `
    #free-item-popup{position:fixed;inset:0;z-index:99999;display:flex;align-items:center;justify-content:center}
    #free-item-popup .fip-backdrop{position:absolute;inset:0;background:rgba(0,0,0,.55)}
    #free-item-popup .fip-modal{position:relative;background:#fff;max-width:460px;width:calc(100% - 32px);
      border-radius:16px;padding:28px 24px;box-shadow:0 20px 60px rgba(0,0,0,.3);text-align:center;font-family:inherit}
    #free-item-popup h3{margin:0 0 6px;font-size:18px;line-height:1.25}
    #free-item-popup p{margin:0 0 20px;color:#555;font-size:16px;line-height:1.45}
    #free-item-popup .fip-close{position:absolute;top:8px;right:14px;border:0;background:none;font-size:26px;cursor:pointer;color:#888}
    #free-item-popup .fip-ok{border:0;background:#111;color:#fff;padding:10px 22px;border-radius:10px;
      font-size:.95rem;font-weight:600;cursor:pointer}
    #free-item-popup .fip-ok:hover{background:#000}
  `;
  document.head.appendChild(css);

  // Re-check after any cart mutation (patch fetch — Dawn uses fetch for cart ops).
  const origFetch = window.fetch;
  window.fetch = function (...args) {
    const url = (args[0] && args[0].url) || args[0] || "";
    return origFetch.apply(this, args).then((res) => {
      if (typeof url === "string" && /\/cart\/(add|change|update|clear)/.test(url)) {
        setTimeout(evaluate, 350);
      }
      return res;
    });
  };
  document.addEventListener("cart:refresh", () => setTimeout(evaluate, 350));

  if (document.readyState !== "loading") evaluate();
  else document.addEventListener("DOMContentLoaded", evaluate);
})();
